import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Layout from "../../Layout";
import Alert from "@material-ui/lab/Alert";
import CollectionGroup from "./collectionGroup";
import CollectionKeyword from "./collectionKeywords";
import MailNotification from "./mailNotification";
import DailyTopicMail from "./dailyTopicMail";
import DictionarySetting from "./dictionarySetting";
import DeleteIcon from "@material-ui/icons/Delete";
import { ValidatorForm } from 'react-material-ui-form-validator';
import useGroupSetting from "Hooks/useGroupSetting";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Paper,
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import useAuth from "Hooks/useAuth";
import useApi from "Hooks/useApi";
import { message } from "constants/message";

const useStyles = makeStyles((theme) => ({
  divider: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    marginTop: theme.spacing(4),
  },
  messsageWrapper: {
    marginTop: theme.spacing(2),
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  danger: {
    color: "#fff",
    backgroundColor: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgb(154, 0, 54)",
    },
  },
}));
export default function CreateGroup({
  state,
  handleSubmit,
  isEdit = false,
  deleteGroup,
}) {
  const { request } = useApi();
  const messages = message();
  const auth = useAuth();
  const groupSetting = useGroupSetting();
  const [isGroupsUpdated, setIsGroupsUpdated] = React.useState(false);
  const [presetKeywords, setPresetKeywords] = React.useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
  const classes = useStyles();

  const initDict = () => {
    fetchDict();
  };

  const fetchDict = () => {
    Promise.all([
      request({
        method: "GET",
        url: `config/:account_id/posi_nega_dict`,
      }),
    ]).then(([dictionary]) => {
      groupSetting.setData("dict_posi", dictionary.data[0].dict_posi);
      groupSetting.setData("dict_nega", dictionary.data[0].dict_nega);
    });
  };

  const fetchKeywordTemplates = () => {
    request({
      method: "GET",
      url: "config/:account_id/keyword_templates?word_type=filter",
    }).then((result) => {
      setPresetKeywords(
        (result.data || []).map((template) => ({
          label: template.name,
          value: (template.words || []).join("\n"),
        }))
      );
    });
  };

  React.useEffect(() => {
    if (!auth.state.user.account_id) {
      return;
    }
    fetchKeywordTemplates();
    // 収集グループ追加時はポジネガ辞書の初期値を取得
    if (!isEdit) {
      fetchDict();
    }
  }, [auth.state.user.account_id]);

  React.useEffect(() => {
    if (auth.state.groups.length <= 0) {
      return;
    }

    if (isEdit) {
      if (!isGroupsUpdated) {
        // 最新の収集グループ情報を更新
        request({
          method: "GET",
          url: "config/:account_id/groups",
        }).then((data) => {
          auth.setGroups(data.data, data.meta);
        });

        setIsGroupsUpdated(true);
      }
    }
  }, [auth.state.groups]);

  const onError = () => {
    groupSetting.setErrors(messages.validation.common)
  };

  return (
    <Layout
      content={
        <>
          <Dialog
            open={deleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
          >
            <DialogContent>
              <DialogContentText>
                本当に削除してよろしいですか？
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="primary"
                onClick={() => {
                  setDeleteModalOpen(false);
                  deleteGroup();
                }}
              >
                はい
              </Button>
              <Button color="primary" onClick={() => setDeleteModalOpen(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>
          <Grid>
            {isEdit && (
              <>
                <Grid container justifyContent="flex-end">
                  <Grid item>
                    <Button
                      variant="contained"
                      className={classes.danger}
                      startIcon={<DeleteIcon />}
                      onClick={() => setDeleteModalOpen(true)}
                    >
                      削除
                    </Button>
                  </Grid>
                </Grid>
              </>
            )}
            <ValidatorForm
              onSubmit={(event) => {
                event.preventDefault();
                handleSubmit();
              }}
              onError={onError}
            >
              <Paper elevation={3} className={classes.paper}>
                <CollectionGroup
                  state={state}
                  changeName={(value) => groupSetting.setData("name", value)}
                />
              </Paper>
              <Paper elevation={3} className={classes.paper}>
                <CollectionKeyword
                  state={state}
                  presetKeywords={presetKeywords}
                  maxWordsOr={auth.state.maxWordsOr}
                  maxWordsAnd={auth.state.maxWordsAnd}
                  maxWordsNot={auth.state.maxWordsNot}
                  changeWordsOr={(value) => {
                    groupSetting.setData("words_or", value);
                  }}
                  changeIgnoreCaseAnd={(value) =>
                    groupSetting.setData(
                      "ignore_case_and",
                      value.target.checked
                    )
                  }
                  changeWordsAnd={(event) =>
                    groupSetting.setData("words_and", event.target.value)
                  }
                  changeIgnoreCaseNot={(value) =>
                    groupSetting.setData(
                      "ignore_case_not",
                      value.target.checked
                    )
                  }
                  changeWordsNot={(event) =>
                    groupSetting.setData("words_not", event.target.value)
                  }
                  changeMentions={(event) =>
                    groupSetting.setData("mentions", event.target.checked)
                  }
                />
              </Paper>
              <Paper elevation={3} className={classes.paper}>
                <MailNotification />
              </Paper>
              <Paper elevation={3} className={classes.paper}>
                <DailyTopicMail
                  state={state}
                  onChangeDtmEnable={(event) => {
                    groupSetting.setData("dtm_enable", event.target.value);
                  }}
                />
              </Paper>
              <Paper elevation={3} className={classes.paper}>
                <DictionarySetting
                  dictPosi={state.dict_posi}
                  dictNega={state.dict_nega}
                  onChangeDictNega={(event) => {
                    groupSetting.setData(
                      "dict_nega",
                      event.target.value.split("\n")
                    );
                  }}
                  onChangeDictPosi={(event) => {
                    groupSetting.setData(
                      "dict_posi",
                      event.target.value.split("\n")
                    );
                  }}
                  initDict={initDict}
                />
              </Paper>
              {state.isCreateSuccess && (
                <div className={classes.messsageWrapper}>
                  <MuiAlert
                    elevation={6}
                    variant="filled"
                    severity="success"
                  >
                    登録が完了しました
                  </MuiAlert>
                </div>
              )}
              {state.isEditSuccess && (
                <div className={classes.messsageWrapper}>
                  <MuiAlert
                    elevation={6}
                    variant="filled"
                    severity="success"
                  >
                    更新が完了しました
                  </MuiAlert>
                </div>
              )}
              {state.isError && (
                <div className={classes.messsageWrapper}>
                  <MuiAlert
                    elevation={6}
                    variant="filled"
                    severity="error"
                    className={classes.toast}
                  >
                    {state.errorMsg}
                  </MuiAlert>
                </div>
              )}
              <Box textAlign="center" className={classes.wrapper}>
                <Button variant="contained" color="primary" type="submit">
                  {isEdit ? "更新" : "登録"}
                </Button>
              </Box>
            </ValidatorForm>
          </Grid>
        </>
      }
    />
  );
}
